import { createContext, useEffect, useReducer } from 'react';
import PropTypes from 'prop-types';
import { authApi } from '../api/auth-api';
import { useNavigate } from 'react-router-dom';
import { Navigate ,useParams} from 'react-router-dom';
import { withRouter } from "react-router-dom";
var ActionType;
(function (ActionType) {
  ActionType['INITIALIZE'] = 'INITIALIZE';
  ActionType['LOGIN'] = 'LOGIN';
  ActionType['LOGOUT'] = 'LOGOUT';
  ActionType['REGISTER'] = 'REGISTER';
})(ActionType || (ActionType = {}));

const initialState = {
  isAuthenticated: false,
  isInitialized: false,
  user: null
};

const handlers = {
  INITIALIZE: (state, action) => {
    const { isAuthenticated, user } = action.payload;

    return {
      ...state,
      isAuthenticated,
      isInitialized: true,
      user
    };
  },
  LOGIN: (state, action) => {
    const { user } = action.payload;

    return {
      ...state,
      isAuthenticated: true,
      user
    };
  },
  LOGOUT: (state) => ({
    ...state,
    isAuthenticated: false,
    user: null
  }),
  REGISTER: (state, action) => {
    const { user } = action.payload;

    return {
      ...state,
      isAuthenticated: true,
      user
    };
  }
};

const reducer = (state, action) => (handlers[action.type]
  ? handlers[action.type](state, action)
  : state);

export const AuthContext = createContext({
  ...initialState,
  platform: 'JWT',
  login: () => Promise.resolve(),
  logout: () => Promise.resolve(),
  register: () => Promise.resolve()
});

export const AuthProvider = (props) => {
  const { children } = props;
  const [state, dispatch] = useReducer(reducer, initialState);
  const navigate = useNavigate();
  const { tenant } = useParams();
const currentPath = window.location.pathname;
      const new_tenant=currentPath.split('/')[1];

  const initialize = async () => {
    
    try {
      if(new_tenant!=globalThis.localStorage.getItem('tenant'))
        {
          localStorage.setItem('tenant', new_tenant);
        }
      const accessToken = globalThis.localStorage.getItem(`accessToken_${new_tenant}`);
          if (accessToken) {
        // window.location.reload(true);
            const user = await authApi.me(accessToken);
  
            dispatch({
              type: ActionType.INITIALIZE,
              payload: {
                // authApi.me() renvoie undefined si l'appel au backend échoue.
                // Sans ce garde-fou on resterait "authentifié" avec un user vide,
                // et les écrans qui lisent user.* planteraient au lieu de rediriger
                // vers la page de connexion.
                isAuthenticated: Boolean(user),
                user: user ?? null
              }
            });
            // navigate(`/${new_tenant}`, { replace: true });
            // window.location.reload(true);
           } else {
            dispatch({
              type: ActionType.INITIALIZE,
              payload: {
                isAuthenticated: false,
                user: null
              }
            });
            // navigate(`/${new_tenant}`, { replace: true });
            // window.location.reload(true);
          }
      
        
      
        // navigate(`/${new_tenant}`, { replace: true });
    } catch (err) {
      console.error(err);
      dispatch({
        type: ActionType.INITIALIZE,
        payload: {
          isAuthenticated: false,
          user: null
        }
      });
    }
  };
  const initializer=async() => {
    await initialize();
    // await new Promise(resolve => setTimeout(window.location.reload(true),   2000));
  };
  useEffect(() => {
   

    initializer();
    
    // navigate(`/${new_tenant}`);
    // window.location.reload(true);
  }, [new_tenant]);

  const login = async (email, password) => {
    const accessToken = await authApi.login(email, password);
    let user = null;
    if (accessToken.jwt) {
      user = await authApi.me(accessToken.jwt);
      if (!user) {
        throw new Error("Connexion impossible : profil utilisateur introuvable");
      }
      const tenant=globalThis.localStorage.getItem('tenant');
    
      localStorage.setItem(`accessToken_${tenant}`, accessToken.jwt);
      // console.log(globalThis.localStorage.getItem("accessToken"));
      dispatch({
        type: ActionType.LOGIN,
        payload: {
          user
        }
      });
      return {done:true,
        first_login:accessToken.first_login,
        new_device:accessToken.new_device
      }
    }
    else {
      dispatch({
        type: ActionType.LOGIN,
        payload: {
          isAuthenticated: false,
          user
        }
      })
      return false
    }
  };

  const logout = async () => {const tenant=globalThis.localStorage.getItem('tenant');
    localStorage.removeItem(`accessToken_${tenant}`);
    dispatch({ type: ActionType.LOGOUT });
  };

  const register = async (email, name, password) => {
    const accessToken = await authApi.register({ email, name, password });
    const user = await authApi.me(accessToken);
    const tenant=globalThis.localStorage.getItem('tenant');
    localStorage.setItem(`accessToken_${tenant}`, accessToken);

    dispatch({
      type: ActionType.REGISTER,
      payload: {
        user
      }
    });
  };

  return (
    <AuthContext.Provider
      value={{
        ...state,
        platform: 'JWT',
        login,
        logout,
        register
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export const AuthConsumer = AuthContext.Consumer;
